import { CircularProgress, Dialog, MenuItem, Select } from '@mui/material';
import { useEffect, useState } from 'react';
import { IoClose } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { get_category, get_event, update_event } from '../Redux/Action/EventAction';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const EventeditModal = ({ Openedit, setOpenedit, event }) => {
    const { t } = useTranslation('CreateEventModal');
    const [loading, setLoading] = useState(false);
    const handleclose = (e) => {
        e.preventDefault();
        setOpenedit(false);
    };

    const dispatch = useDispatch();
    const { category } = useSelector((state) => state.Create);

    const [input, setinput] = useState({
        name: '',
        date: null,
        category_id: '',
    });

    useEffect(() => {
        dispatch(get_category());
        if (event) {
            setinput({
                name: event.name || '',
                date: event.date ? dayjs(event.date) : null,
                category_id: event.category_id || '',
            });
        }
    }, [dispatch, event]);

    const handlesubmit = (e) => {
        e.preventDefault();
        if (!input.name || !input.date || !input.category_id) {
            toast.error(t("toastError"));
            return;
        }
        setLoading(true);
        const payload = {
            name: input.name,
            date: input.date ? input.date.format("YYYY-MM-DD") : '',
            category_id: input.category_id,
            id: event.id,
        };

        dispatch(update_event(event.id, payload))
            .then(() => {
                setOpenedit(false);
                dispatch(get_event());
                toast.success(t("update_success"));
            })
            .catch((error) => {
                toast.error(t("update_errormsg"));
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <>
            <Dialog
                open={Openedit}
                onClose={() => setOpenedit(false)}
                PaperProps={{
                    sx: {
                        borderRadius: "20px",
                        width: "480px",
                    },
                }}
            >
                <div className="bg-white p-7 flex flex-col gap-5 rounded-[20px]">
                    <div className="flex justify-between items-center w-full">
                        <div className="text-[20px] font-[600]">{t("titlemodal")}</div>
                        <span onClick={handleclose}><IoClose size={25} className='cursor-pointer' /></span>
                    </div>

                    <form action="" method="POST" className='bg-white flex flex-col grid gap-5 rounded-[20px]' onSubmit={handlesubmit}>
                        <div className="grid gap-8">
                            <div className="flex flex-col gap-2 w-full">
                                <span className='text-[14px] font-500 text-[#131415] text-left'>{t("nameLabel")}</span>
                                <input type='text' placeholder={t("namePlaceholder")}
                                    className='border border-[#c3cbd7] py-[12px] rounded-[10px] px-3 text-[14px] w-full'
                                    value={input.name}
                                    name='name'
                                    onChange={(e) => setinput({
                                        ...input, [e.target.name]: e.target.value
                                    })}
                                />
                            </div>

                            {/* Updated Date Picker */}
                            <div className="flex flex-col gap-2">
                                <span className='text-[14px] font-500 text-[#131415] text-left'>{t("dateLabel")}</span>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={input.date}
                                        onChange={(newValue) => setinput({ ...input, date: newValue })}
                                        format="DD-MM-YYYY"
                                        slotProps={{
                                            textField: {
                                                InputProps: {
                                                    style: {
                                                        borderRadius: "10px",
                                                        fontSize: "13px",
                                                        borderColor: "#c3cbd7",
                                                        width: "100%",
                                                    },
                                                },
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>

                            <div className="flex flex-col gap-2">
                                <span className='text-[14px] font-500 text-[#131415] text-left'>{t("categoryLabel")}</span>

                                <Select className='px-2 text-[14px]'
                                    value={input.category_id}
                                    onChange={(e) => setinput({
                                        ...input, category_id: e.target.value
                                    })}
                                    displayEmpty
                                    renderValue={(selected) => {
                                        const selectedCategory = category.data && category.data.find((event) => event.id === selected);
                                        return selectedCategory ? selectedCategory.name : '';
                                    }}
                                    sx={{ border: 'none', borderRadius: 3, borderColor: '#c3cbd7', height: '49px', fontSize: 14 }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                marginTop: '7px',
                                                borderRadius: '8px',
                                            },
                                        },
                                    }}
                                >
                                    {
                                        category.data && category.data.map((items) => (
                                            <MenuItem key={items.id} value={items.id} sx={{ fontSize: 14 }}>
                                                {items.name}
                                            </MenuItem>
                                        ))
                                    }
                                </Select>
                            </div>

                            <div className="flex gap-5 justify-center">
                                <button className='bg-[#EDF4FF] text-black rounded-lg h-[40px] w-full max-w-32 my-1 text-[14px] text-center' onClick={handleclose}>
                                    {t("btn_cancel")}
                                </button>
                                <button className='bg-[#3686FF] text-white rounded-lg h-[40px] w-full max-w-32 my-1 text-[14px] text-center' type="submit" disabled={loading}>
                                    {loading ? <CircularProgress size={20} color="inherit" /> : t("btn_update")}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </Dialog>
        </>
    );
};

export default EventeditModal;